
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/introducing-base-ui",
      function () {
        return require("private-next-pages/blog/introducing-base-ui.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/introducing-base-ui"])
      });
    }
  